<template>
    <div class="daily-rancing">
        <div class="daily-rancing__table scrollbar">
            <div class="daily-rancing__header">
                <div>NGƯỜI CHƠI</div>
                <div>THẮNG</div>
                <div>HÒA</div>
                <div>THUA</div>
                <div>TỔNG ĐIỂM</div>
            </div>
            <div class="daily-rancing__content">
                <ul v-if="listSummary" class="content">
                    <li v-for="(item, index) in listSummary" :key="index" :class="{'current-user': item.isCurrentUser}">
                        <div class="user">
                            <span class="position">{{index + 1}}</span>
                            <img class="avatar" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-slots/avatar.png`" alt="avatar">
                            <span class="name">{{item.username}}</span>
                        </div>
                        <div><span class="number">{{item.match_win}}</span></div>
                        <div><span class="number">{{item.match_draw}}</span></div>
                        <div><span class="number">{{item.match_lose}}</span></div>
                        <div class="total"><span>{{item.total_point}}</span></div>
                    </li>
                </ul>
                <div v-else class="not-data text-center">
                    <img class="icon" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/icon-empty.svg`" alt="empty">
                    <div class="top">TOP TRỐNG</div>
                    <div class="sub">Hệ thống sẽ cập nhật thông tin sớm nhất!</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState } from 'vuex';

export default {
    data() {
        return {
            isLoading: false,
            isSubmit: false
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        },
        ...mapState('event/worldcup-wheel', {
            listSummary: state => state.summary.listSummary,
            currentUserLogin: state => state.summary.currentUserLogin
        })
    },
    methods: {
        async getTopMedal() {
            try {
                if (this.isLoading) {
                    return;
                }
                this.isLoading = true;
                await this.$store.dispatch('event/worldcup-wheel/getTopMedal');
                this.isLoading = false;
                this.isSubmit = false;
            } catch (error) {
                console.log(error);
                this.isSubmit = false;
                this.isLoading = false;
                this.$alertError('Server lỗi ! Vui lòng thử lại sau!');
            }
        }
    },
    mounted() {
        this.$nextTick(async () => {
            await this.getTopMedal();
        });
    }
};
</script>
